import { cn } from "@omni/utils/styles";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

import { BaseFieldArray } from "@/components/Form/RHF/FormFields/BaseFieldArray/baseFieldArray.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { TermsOfServiceDocumentField } from "./components/termsOfServiceDocumentField.component";
import { TermsOfServiceDocumentFieldItem } from "./components/termsOfServiceDocumentFieldItem.component";
import { TermsOfServiceFieldValues } from "./termsOfServiceCheck.schema";

const TermsOfServiceCheckField = <
    _ extends TermsOfServiceFieldValues = never
>() => {
    const { t } = useGranite();
    const { subscribe, getValues } =
        useFormContext<TermsOfServiceFieldValues>();
    const [hasAdditionalService, setHasAdditionalService] = useState(
        getValues("termsOfServiceChecks")?.length > 0
    );

    useEffect(() => {
        const callback = subscribe({
            formState: { values: true },
            callback: ({ values }) => {
                const shouldHaveAdditionalService =
                    values.termsOfServiceChecks?.length > 0;
                if (shouldHaveAdditionalService !== hasAdditionalService) {
                    setHasAdditionalService(shouldHaveAdditionalService);
                }
            }
        });

        return () => callback();
    }, [subscribe, hasAdditionalService]);

    if (!hasAdditionalService) {
        return null;
    }

    return (
        <section className={cn("tw:mb-6")}>
            <h2>
                {t(
                    "checkout.customerDetails.additionalServiceTermsOfService.title"
                )}
            </h2>
            <hr />
            <div className={cn("tw:pb-4")}>
                <BaseFieldArray<
                    TermsOfServiceFieldValues,
                    "termsOfServiceChecks"
                >
                    name={"termsOfServiceChecks"}
                    label={""}
                    hideLabel={true}
                    microCopy={""}
                    required={true}
                >
                    {({ actions, control, fields, name }) => {
                        return (
                            <TermsOfServiceDocumentField<TermsOfServiceFieldValues>
                                actions={actions}
                                control={control}
                                fields={fields}
                                name={name}
                                renderDocument={(
                                    fieldItem,
                                    field,
                                    index,
                                    fieldState
                                ) => {
                                    return (
                                        <TermsOfServiceDocumentFieldItem
                                            name={field.name}
                                            document={fieldItem}
                                            fieldState={fieldState}
                                            onChange={() => {
                                                actions.update(index, {
                                                    ...fieldItem,
                                                    checked: !fieldItem.checked
                                                });
                                                actions.trigger();
                                            }}
                                        />
                                    );
                                }}
                            />
                        );
                    }}
                </BaseFieldArray>
            </div>
        </section>
    );
};

export { TermsOfServiceCheckField };
